'use client';

import type { ReactNode } from 'react';

export const DebugLinkLogger = ({ children }: { children: ReactNode }) => {
  const handleClick = () => {
    const reqId = Math.random().toString(36).slice(2, 10);
    document.cookie = `__debug_req_id=${reqId}; path=/; max-age=30`;

    const rawCookies = document.cookie.split(';').map(c => c.trim());
    const cookieNames = rawCookies.map(c => c.split('=')[0]);
    const utpMatches = rawCookies.filter(c => c.startsWith('__utp='));
    const utpValue = utpMatches[0]?.split('=').slice(1).join('=');

    let pianoUid = 'unknown';
    if (utpValue) {
      try {
        const base64Url = utpValue.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(atob(base64));
        pianoUid = payload.sub ?? 'unknown';
      } catch {
        pianoUid = 'decode_failed';
      }
    }

    navigator.sendBeacon('/api/debugLog', JSON.stringify({
      flag: '[getIsLoggedIn pre-request]',
      reqId,
      pianoUid,
      utpCount: utpMatches.length,
      utpLength: utpValue?.length ?? null,
      dotCount: utpValue?.split('.').length ?? 0,
      totalCookieHeaderLength: document.cookie.length,
      cookieNames,
    }));
  };

  return (
    <div onClick={handleClick}>
      {children}
    </div>
  );
};
